import React from "react";

const FieldError = ({ fieldName = "" }) => {
  return <p className="error-para" style={{ color: "red" }}>{fieldName || ""}</p>;
};

export default FieldError;
